<template>
  <success title="已保存" :btn-list="btnData"></success>
</template>
<script>
import { allBtn } from './btnList'
import Success from '../../components/Success'

export default {
  components: { Success },
  data() {
    return {
      btnData: []
    }
  },
  created() {
    let id = this.$route.params.id // 新建车辆还是车辆到店
    let source = this.$route.params.source
    let btnSource = allBtn[source](id)
    if (source === 'inquiry') {
      this.$rest.usedCar.getTicket(null, `${id}/operations`).then(res => {
        if (res.code === 0) {
          // 获取二手车线索支持的操作
          let enquirySupport = res.data.operations.is_support_enquiry
          this.btnData = enquirySupport ? btnSource : btnSource.slice(1)
        } else {
          this.showToast(res.message)
        }
      })
    } else if (source === 'auction') {
      this.$store.state.promiseAuth.then(auth => {
        let btn = []
        let enquiryCreate = auth.authList.includes('used_car_car.enquiry.create')
        let auctionCreate = auth.authList.includes('used_car_car.auction.create')
        if (auctionCreate) btn.push(btnSource[0])
        if (enquiryCreate) btn.push(btnSource[1])
        btn.push(btnSource[2])
        this.btnData = btn
      })
    }
  }
}

</script>
<style lang="less"></style>
